<div class="social-chat">
    <div>
        <ul class="chat-list">
            <li *ngFor = "data of [1,2,3,4,5,6,7,8,9,10,11,12,13,14]">
                <div class="user-img">
                    <div class="ratio-slider ratio-1-1">
                        <img src="https://i.pinimg.com/originals/bf/41/21/bf4121c128f55a088be0ae3f1dbcea46.jpg" />
                    </div>
                </div>
                <div class="user-details">
                    <h6>
                        Kenny Smith
                    </h6>
                    <h5 class="font-bold">
                        That's a partty song.
                    </h5>
                </div>
            </li>
        </ul>
        <div class="form-group">
            <input type="text" placeholder="Write your comment" />
            <button type="button" class="send-btn">
                <span class="icon-send"></span>
            </button>
        </div>
    </div>
</div>